import React, { FC } from 'react';
import { Card, CardBody, Col, Row, Table } from 'reactstrap';
import { tzCorrectedDate } from '../../../../shared/util/tzCorrectedDate';
import { Currency } from '../../../components/Currency';
import { useTranslation } from '../../../translations';
import { Fetcher, useFetcher } from '../../../utils';

export const HotelList: FC = () => {
  const hotels = useFetcher(async () => {
    return await api.getHotels();
  });

  const { ts } = useTranslation();

  if (!hotels.success) {
    return <Fetcher result={hotels} />;
  }

  const format = new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  return (
    <>
      <h2>{ts('list_of_hotels')}</h2>
      <p>{ts('here_is_a_list_of_your_hotels')}</p>
      <Row>
        {hotels.data.map((hotel) => (
          <Col key={hotel.id} md={4}>
            <Card>
              <CardBody>
                <h2>{hotel.name}</h2>
                <p>Visible: {hotel.isVisible ? 'Yes' : 'No'}</p>
                <p>
                  {hotel.addressLine1}
                  <br />
                  {hotel.addressLine2}
                  {hotel.addressLine2 ? <br /> : ''}
                  {hotel.addressCity}, {hotel.addressState} {hotel.addressZipcode}
                  <br />
                  {hotel.addressCountry}
                </p>
                {hotel.phone && (
                  <div>
                    {ts('phone')}: <a href={`tel:${hotel.phone}`}>{hotel.phone}</a>
                  </div>
                )}
                {hotel.website && (
                  <div>
                    Website: <a href={hotel.website}>{hotel.website}</a>
                  </div>
                )}

                <hr />

                <h3>{ts('rooms')}</h3>

                {hotel.rooms.map((room) => (
                  <div key={room.id}>
                    <h4>{room.name}</h4>
                    <p>Max Occupancy: {room.maxOccupancy}</p>
                    <Table className="table" striped>
                      <thead>
                        <tr>
                          <th>{ts('count')}</th>
                          <th>{ts('rate')}</th>
                          <th>{ts('available_on')}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {room.availability.length === 0 ? (
                          <tr>
                            <td colSpan={3}>{ts('no_availability')}</td>
                          </tr>
                        ) : (
                          room.availability
                            .sort(
                              (a, b) =>
                                new Date(a.availableOn).getTime() -
                                new Date(b.availableOn).getTime(),
                            )
                            .map((availability) => (
                              <tr key={availability.id}>
                                <td className={availability.count === 0 ? 'text-danger' : ''}>
                                  {availability.count}
                                </td>
                                <td>
                                  <Currency value={availability.rate} />
                                </td>
                                <td>
                                  {format.format(
                                    tzCorrectedDate(new Date(availability.availableOn)),
                                  )}
                                </td>
                              </tr>
                            ))
                        )}
                      </tbody>
                    </Table>
                  </div>
                ))}
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>
    </>
  );
};
